const USER_KEY = 'user';

function getWindowSafe() {
  return typeof window !== 'undefined' ? window : undefined;
}

export function getStoredUser() {
  const win = getWindowSafe();
  if (!win) return null;

  const sessionValue = win.sessionStorage.getItem(USER_KEY);
  if (sessionValue) {
    try {
      return JSON.parse(sessionValue);
    } catch {
      return null;
    }
  }

  const legacyValue = win.localStorage.getItem(USER_KEY);
  if (!legacyValue) return null;
  try {
    const parsed = JSON.parse(legacyValue);
    win.sessionStorage.setItem(USER_KEY, legacyValue);
    win.localStorage.removeItem(USER_KEY);
    return parsed;
  } catch {
    win.localStorage.removeItem(USER_KEY);
    return null;
  }
}

export function setStoredUser(user) {
  const win = getWindowSafe();
  if (!win) return;

  try {
    const serialized = JSON.stringify(user);
    win.sessionStorage.setItem(USER_KEY, serialized);
    win.localStorage.removeItem(USER_KEY);
    win.dispatchEvent(new Event('userUpdated'));
  } catch {
    // swallow serialization errors
  }
}

export function clearStoredUser() {
  const win = getWindowSafe();
  if (!win) return;

  win.sessionStorage.removeItem(USER_KEY);
  win.localStorage.removeItem(USER_KEY);
  win.dispatchEvent(new Event('userUpdated'));
}

